import $http from '@/config/request';

//我的知识单--播单列表
export const getKnowledgeAllList = params => {
  return $http.get(`/resource/user-group/lists?userNo=${ params.userNo }&pageNum=${ params.pageNum }&pageSize=${ params.pageSize }`);
};

//我的知识单--创建播单
export const addKnowledgeApi = params => {
  return $http.post('/resource/user-group/add/group', params);
};


//我的知识单--删除播单
export const deleteKnowledge = params => {
  return $http.post('/resource/user-group/del/group', params);
};

//知识单播放页
export const knowledgeList = params => {
  return $http.get(`/resource/user-group/parts?groupID=${ params.groupID }`);
};

//获取播单详情
export const getKnowledgeDetail = params => {
  return $http.get(`/resource/user-group/groupdetail?groupID=${ params.groupID }&userNo=${ params.userNo }`);
};

//删除播单的知识点
export const deleteKnowledgeList = params => {
  return $http.post('/resource/user-group/unbind/part', params);
};

//播单知识点排序
export const sortKnowledgeList = params => {
  return $http.post('/resource/user-group/order/part', params);
};
